<script>
    import Trabajador from "./Trabajador.svelte";

    export let trabajadores;
    export let activos;
</script>

<style>
    ul {
        --anchoMinimo: calc(var(--ancho) / 4 - var(--padding-global));
        margin: 0;
        padding: 0;
        list-style: none;
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(var(--anchoMinimo), 1fr));
        grid-gap: var(--padding-global);
    }

    li {
        display: flex;
        flex-direction: column;
        height: 100%;
    }
</style>

<div class="parrillaDeTrabajadores">
    <div class="inner">
        <ul>
            {#each trabajadores as trabajador (trabajador.id)}
                <li>
                    <Trabajador activos={activos} {trabajador} on:eliminar-trabajador on:restaurar-trabajador />
                </li>
            {/each}
        </ul>
    </div>
</div>